import { defineStore } from 'pinia';

import { useRecipeStore } from '@apps/main/new-desktop/core/stores/recipe/recipeStore';
import { FerryEndpoint } from '@apps/main/modules/api/ferry';

export const useStaticDataStore = defineStore('StaticDataStore', () => {
  const recipeStore = useRecipeStore();

  // Actions
  function setAllowMultipleVehiclesToFerryIngredients(): void {
    const ferryEndpoint = new FerryEndpoint();
    recipeStore.ferryOnlyRecipe.forEach((ferryIngredient) => {
      if (ferryIngredient.fromPort && ferryIngredient.toPort) {
        ferryEndpoint
          .getFerryRouteStaticInfo(
            ferryIngredient.fromPort,
            ferryIngredient.toPort
          )
          .subscribe((ferryRoute) => {
            if (ferryRoute) {
              ferryIngredient.setAllowMultipleVehicles(
                ferryRoute.allowMultipleVehicles
              );
              ferryIngredient.setAllowVehicles(ferryRoute.allowVehicles);
              ferryIngredient.setPortCountry(
                ferryRoute.from.country,
                ferryRoute.to.country
              );
            }
          });
      }
    });
  }

  return {
    // Actions
    setAllowMultipleVehiclesToFerryIngredients,
  };
});
